import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center pt-16">
      {/* 背景图 */}
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20moody%20background%20with%20warm%20amber%20and%20deep%20crimson%20gradient%20lighting%2C%20abstract%20geometric%20patterns%20subtle%20in%20background%2C%20mysterious%20cinematic%20atmosphere%2C%20red%20carpet%20texture%20hints%2C%20editorial%20photography%20style%2C%20high%20contrast%2C%20professional%20composition%2C%20dark%20elegant%20aesthetic&width=1600&height=900&seq=hero-bg-2026-x1&orientation=landscape"
          alt="吃瓜爆料网 - 网红黑料大瓜每日首发更新"
          className="w-full h-full object-cover object-top"
          title="吃瓜爆料网 - 网红黑料大瓜每日首发更新"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>

      {/* 内容 */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="w-full lg:w-[40%] flex flex-col items-center lg:items-start text-center lg:text-left">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-extrabold text-background-50 leading-tight mb-4">
              吃瓜爆料网
            </h1>
            <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-8 max-w-md">
              网红塌房、黑料大瓜每日首发更新。一站导航吃瓜爆料网官网、吃瓜爆料网APP下载与吃瓜爆料网最新地址，实时追踪不停更。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/wanghong-tafang"
                className="whitespace-nowrap px-6 py-3 bg-background-50/90 text-foreground-950 rounded-full text-sm font-semibold hover:bg-background-50 transition-colors duration-200 cursor-pointer text-center"
              >
                立即吃瓜
              </Link>
              <Link
                to="/about"
                className="whitespace-nowrap px-6 py-3 border border-background-50/60 text-background-50 rounded-full text-sm font-semibold hover:bg-background-50/10 transition-colors duration-200 cursor-pointer text-center"
              >
                下载APP
              </Link>
            </div>
          </div>

          <div className="w-full lg:w-[60%]">
            <div className="relative rounded-2xl overflow-hidden aspect-[16/9] lg:aspect-[16/8]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20breaking%20news%20scene%20with%20warm%20amber%20spotlight%20on%20a%20smartphone%20displaying%20shocking%20social%20media%20content%2C%20dark%20moody%20background%20with%20cinematic%20film%20grain%2C%20mysterious%20atmosphere%2C%20red%20and%20gold%20color%20tones%2C%20editorial%20photography%2C%20high%20contrast%2C%20dramatic%20lighting&width=1200&height=600&seq=hero-feature-2026-x1&orientation=landscape"
                alt="吃瓜爆料网每日首发网红黑料大瓜"
                className="w-full h-full object-cover"
                title="吃瓜爆料网每日首发网红黑料大瓜"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <span className="inline-block px-3 py-1 bg-primary-500/90 text-background-50 text-xs font-semibold rounded-full">
                  今日重磅
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}